import { render, staticRenderFns } from "./SimilarProposals.vue?vue&type=template&id=973bba6a&"
import script from "./SimilarProposals.vue?vue&type=script&lang=js&"
export * from "./SimilarProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports